import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Avatar, Box, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { QuickActionMenuItemProps as Props } from './types';

export const QuickActionMenuItem = memo(
  ({
    className,
    icon,
    title,
    onClick,
    hasChildren,
    childState,
    disabled,
    avatar,
    endIcon,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('QuickActionMenuItem', className)}
        sx={SX.root({ focus: childState?.value, disabled })}
        onClick={onClick}
      >
        <Box display={'flex'} alignItems={'center'} gap={1}>
          {avatar && <Avatar src={avatar} size={24} variant="rounded" />}

          {icon && (
            <Icon
              name={icon}
              size={18}
              color={!disabled ? 'grey.600' : 'grey.300'}
            />
          )}

          <Typography
            variant="body4"
            color={!disabled ? 'grey.600' : 'grey.300'}
          >
            {title}
          </Typography>
        </Box>

        {endIcon}

        {hasChildren && (
          <Icon name={'chevron-right'} size={18} color="grey.600" />
        )}
      </Styled.Wrapper>
    );
  }
);

QuickActionMenuItem.displayName = 'QuickActionMenuItem';
